import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchCmsMetaData } from "../../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../../Components/Utility/setMetaTags";

function UserNotification() {
  const [notifications, setNotifications] = useState([]);
   const [loading, setLoading] = useState(true);
   const [meta,setMeta] = useState();

  // Fetch notifications on component mount
  useEffect(() => {
    fetchNotifications();
  }, []);
  useEffect(() => {
			window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); // ya "auto"
		  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE}/user/getNotifications`,
		{
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
	  );
      setNotifications(response.data.data || []);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }finally {
      setLoading(false); // 👈 data load hone ke baad skeleton hata do
    }
  };

  // const deleteNotification = async (id) => {
  //   try {
  //     await axios.post(`${process.env.REACT_APP_API_BASE}/user/deleteNotification`, { notification_id: id },
	// 	{
  //           headers: {
  //             Authorization: `Bearer ${localStorage.getItem("authToken")}`,
  //           },
  //         }

	//   );
  //     // Remove deleted notification from state
  //     setNotifications(notifications.filter((n) => n.id !== id));
  //   } catch (error) {
  //     console.error("Error deleting notification:", error);
  //   }
  // };



   useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("notification");
      setMeta(data);
    };

    loadMeta();
  }, []);
// Skeleton Loader Component (same format as notification)
const SkeletonNotification = () => (
  
  <div className="nt_listing flex items-center space-x-4 mb-4 animate-pulse">
    {/* Bell Icon Skeleton */}
    <div className="mg_icons">
      <div className="w-6 h-6 bg-gray-300 rounded-full"></div>
    </div>

    {/* Message + Date Skeleton */}
    <div className="red_contct  skeleton-text">
      <div className="skeleton-text"></div>
      <div className="h-2 bg-gray-200 rounded w-1/4"></div>       {/* date placeholder */}
    </div>
  </div>
);


  return (
    <section className="mng_bottomss user_allls notificationsss">
       <SetMetaTags
        title= {meta?.meta_title || "Notification | Weyfarin"}
        description={meta?.meta_description || "Notification | Weyfarin"}
      
      />

	    <div className="bedcramss">
				  <Link to="/profile">
            Dashboard
          </Link>{" "}
          &gt; Notifications
				</div>
        <div className="prfo_listst lastsst al_sec_ctxt notifications pt-4">
          <h4>Notifications</h4>
		  <div className="main_ntf_area">
          {loading && (
  <>
    <SkeletonNotification />
    <SkeletonNotification />
    <SkeletonNotification />
  </>
)}


            {!loading && notifications.length === 0 && (
              <p>No notifications found.</p>
            )}

          {notifications.map((notif) => (
            <div className="nt_listing" key={notif.id}>
              <div className="mg_icons">
                <i className="fa fa-bell-o"></i>
              </div>
              <div className="red_contct">
                <p>{notif.message}</p>
                <span>{new Date(notif.created_at).toLocaleDateString()}</span>
              </div>
              {/* <div
                className="off_on"
                onClick={() => deleteNotification(notif.id)}
                style={{ cursor: "pointer" }}
              >
                <i className="fa fa-times"></i>
              </div> */}
            </div>
          ))}
        </div>
        </div>
    </section>
  );
}

export default UserNotification;
